/* eslint-disable @typescript-eslint/no-explicit-any */
import styles from './markdown-extended.module.css';
import { notoSerif } from '@/app/ui/fonts';

import ReactMarkdown from 'react-markdown';
import rehypeKatex from 'rehype-katex';
import rehypeParse from 'rehype-parse';
import rehypeStringify from 'rehype-stringify';
import remarkMath from 'remark-math';
import remarkGfm from 'remark-gfm';
import rehypeKatexMathML from '@/app/lib/plugins/rehype-katex-mathml';

import 'katex/dist/katex.min.css';
import { Note } from '@prisma/client';
import NoteContent from '../components/problem/note-content';
import { Box, Flex } from '@radix-ui/themes';
import StoreProvider from '../components/store-provider';
import FigureContainer from '../components/problem/figure-container';

interface Props {
  markdown: string;
  notes?: Note[];
  // lightboxPortal?: HTMLElement | null | undefined;
  lightboxPortalId?: string;
}
export default function MarkdownExtended({
  markdown,
  notes,
  lightboxPortalId
}: Props) {
  const components = {
    p(props: any) {
      const { children } = props;
      return <Box py='2'>{children}</Box>;
    },
    h2(props: any) {
      const { children } = props;
      return <h2>{children}</h2>;
    },
    h3(props: any) {
      const { children } = props;
      return <h3>{children}</h3>;
    },
    img(props: any) {
      const { src, alt } = props;

      const legendArray = alt.split(' alt ');
      const figureCaption =
        legendArray.length > 1 ? legendArray[0] : legendArray[0];
      const altText = legendArray.length > 1 ? legendArray[1] : legendArray[0];

      return (
        <Flex
          direction='column'
          gap='2'
          align='center'
          py='4'
        >
          <FigureContainer
            src={src}
            alt={altText}
            lightboxPortalId={lightboxPortalId ? lightboxPortalId : ''}
          />
          <div className={styles.AltText}>
            <ReactMarkdown
              remarkPlugins={[remarkMath, remarkGfm]}
              rehypePlugins={[
                rehypeParse, // Разбирает HTML
                rehypeKatex, // Преобразует LaTeX в KaTeX
                rehypeKatexMathML, // Добавляет MathML
                rehypeStringify // Преобразует дерево обратно в HTML
              ]}
            >
              {figureCaption}
            </ReactMarkdown>
          </div>
        </Flex>
      );
    },
    code(props: any) {
      const { children } = props;
      const note = notes?.find(note => note.label.toString() === children);

      if (!note) return null;
      return (
        <StoreProvider>
          <NoteContent markdown={note.content} />
        </StoreProvider>
      );
    }
  };

  return (
    <div className={`${notoSerif.className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkMath, remarkGfm]}
        rehypePlugins={[rehypeKatex]}
        components={components}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
}
